import { __extends } from 'tslib';
import * as React from 'react';
import { UitkSheetContent } from 'uitk-react-sheet';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-dialog.css';

var getClassNameList = classNames.bind(styles);
var UitkDialogContent = /** @class */ (function (_super) {
    __extends(UitkDialogContent, _super);
    function UitkDialogContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkDialogContent.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, contentDomRef = _a.contentDomRef, zeroPadding = _a.zeroPadding;
        var wrapperClassNames = getClassNameList('uitk-dialog-content', className, {
            'default-padding': !zeroPadding
        });
        return (React.createElement(UitkSheetContent, { className: wrapperClassNames, padded: !zeroPadding, contentDomRef: contentDomRef }, children));
    };
    UitkDialogContent.displayName = 'UitkDialogContent';
    return UitkDialogContent;
}(React.PureComponent));

export { UitkDialogContent };
